function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.82513 3.175C8.01013 2.36 6.85513 1.89 5.58513 2.02C3.75013 2.205 2.24013 3.695 2.03513 5.53C1.76013 7.955 3.63513 10 6.00013 10C7.59513 10 8.96513 9.065 9.60513 7.72C9.76513 7.385 9.52513 7 9.15513 7C8.97013 7 8.79513 7.1 8.71513 7.265C8.15013 8.48 6.79513 9.25 5.31513 8.92C4.20513 8.675 3.31013 7.77 3.07513 6.66C2.65513 4.72 4.13013 3 6.00013 3C6.83013 3 7.57013 3.345 8.11013 3.89L7.35513 4.645C7.04013 4.96 7.26013 5.5 7.70513 5.5H9.50013C9.77513 5.5 10.0001 5.275 10.0001 5V3.205C10.0001 2.76 9.46013 2.535 9.14513 2.85L8.82513 3.175Z"
  }));
};

export default SvgComponent;